__turbopack_context__.v({
  "button": "Tags-module-scss-module__ZS5Oyq__button",
  "link": "Tags-module-scss-module__ZS5Oyq__link",
});
